import { getLocalStorage } from "components/Helper/Helper";
import { LOADER_STATUS, FILE_DATA } from "./constants";
import { Config } from "../../../Config.js";
import { toast } from "react-toastify";
import axios from "axios";


const handlemonth=(value)=> {
  const dateString = value;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is zero-based, so we add 1
  let temp =month < 10 ? 0 + month.toString() : month
  const resultDate =   temp.toString()+year.toString();
  return resultDate;
}
async function errorNot(errMsgVal) {
  await toast.success(`${errMsgVal}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

async function errorNotErr(errMsgVal) {
  toast.error(`${errMsgVal}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
export function loader(status) {
    return {
      type: LOADER_STATUS,
      loaderStatus: status,
    };
}

export function setAnalyticsData(fileData) {
  return {
    type: FILE_DATA,
    fileData: fileData,
  };
}
export function getAnalyticsTableData(selectedGSTIN,startDate, endDate) {
  let rpt_from = handlemonth(startDate);
let rpt_to = handlemonth(endDate);
    return (dispatch) => {
        dispatch(loader(true));
       let data = {
        gstin:selectedGSTIN.join(','),
        rpt_to: rpt_to,
        rpt_from:rpt_from ,
       }
        return new Promise((resolve, reject) => {
          axios({
            method: "post",
            url: `${Config.url}itc04/getitc_analytics`,
            data: data,
            headers: {
              token: getLocalStorage("loginDetails"),
            },
        })
        .then((response) => {
            if(response.data.error == 0){
              errorNot("Run Report Successful");                           
              dispatch(setAnalyticsData(response.data.data));             
              resolve(response.data.data);
            }else {
              errorNotErr(response.data.message);
              resolve([]);
              dispatch(setAnalyticsData([]));
            }
            dispatch(loader(false))
            ;
          })
          .catch((error) => {
            dispatch(loader(false));
            console.log(error);
            reject(true);
            });
        });
      };
  }; 

export const downloadAnalyticsTableData = (selectedGSTIN,startDate, endDate) => {

  let rpt_from = handlemonth(startDate);
  let rpt_to = handlemonth(endDate);
    return (dispatch) => {
      dispatch(loader(true));
      let data = {
        gstin:selectedGSTIN.join(','),
        rpt_to: rpt_to,
        rpt_from: rpt_from,
        isDownload: true,
       }
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          data: data,
          url: `${Config.url}itc04/getitc_analytics`,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
          responseType: "blob",
        })
          .then((response) => {
            if(response.data.error == 0 || response.data){
              errorNot("Data Downloaded");
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "ITC04_Analytics_data.xlsx");
              document.body.appendChild(link);
              link.click();
    
              resolve(true);
              dispatch(loader(false));}
              else{
                errorNotErr("Data not Found");
              }
          })
          .catch((error) => {
            reject(true);
            dispatch(loader(false));
            
          });
      });
    };
  };